/**
 * Stock binario / pausa: EnPausa=true.
 * Detalle API: habilitado=false también cubre stock numérico sin stock.
 */
export function isProductoAgotado (product) {
  if (!product) return false
  if (product.EnPausa === true) return true
  if (product.habilitado === false) return true
  return false
}
